import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGitSquare } from '@fortawesome/free-brands-svg-icons';
import Appstore from '../../assets/img/iphone/appstore.png';

function MobileProject({
  image,
  title,
  subtitle,
  appstore,
  desc,
  stack,
  link,
}) {
  return (
    <li className="iphone-project">
      <img
        src={image}
        alt={title}
        className="iphone-image"
      />
      <div className="portfolio-info iphone-info">
        <h3 className="portfolio-info__subtitle">{subtitle}</h3>
        <h2 className="portfolio-info__title">{title}</h2>
        {appstore && (
          <a
            className="appstore-container"
            href={appstore}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="appstore-image"
              src={Appstore}
              alt="Download on the App Store"
            />
          </a>
        )}
        <p className="portfolio-info__text iphone-info__text">{desc}</p>
        <ul className="portfolio-info__stack">
          {stack.map((item) => (
            <li
              key={item}
              className="portfolio-info__stack-item"
            >
              {item}
            </li>
          ))}
        </ul>
        <ul className="portfolio-info__icons-list">
          <li className="portfolio-info__icons-item">
            <a
              href={link}
              target="_blank"
              className="fa fa-github-alt"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faGitSquare} />
            </a>
          </li>
        </ul>
      </div>
    </li>
  );
}

export default MobileProject;
